export { VanillaMobileNavigation } from './VanillaMobileNavigation';
